var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconInfoCircle',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.text, classes: _vm.fullWidth ? '' : 'max-width-300' }),expression:"{ content: text, classes: fullWidth ? '' : 'max-width-300' }"}],staticClass:"form-tooltip-icon"})
}
var staticRenderFns = []

export { render, staticRenderFns }